var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 7.50033H10.8327V5.83366H9.16602M9.99935 16.667C6.32435 16.667 3.33268 13.6753 3.33268 10.0003C3.33268 6.32533 6.32435 3.33366 9.99935 3.33366C13.6743 3.33366 16.666 6.32533 16.666 10.0003C16.666 13.6753 13.6743 16.667 9.99935 16.667ZM9.99935 1.66699C8.905 1.66699 7.82137 1.88254 6.81032 2.30133C5.79927 2.72012 4.88061 3.33395 4.10679 4.10777C2.54399 5.67057 1.66602 7.79019 1.66602 10.0003C1.66602 12.2105 2.54399 14.3301 4.10679 15.8929C4.88061 16.6667 5.79927 17.2805 6.81032 17.6993C7.82137 18.1181 8.905 18.3337 9.99935 18.3337C12.2095 18.3337 14.3291 17.4557 15.8919 15.8929C17.4547 14.3301 18.3327 12.2105 18.3327 10.0003C18.3327 8.90598 18.1171 7.82234 17.6983 6.8113C17.2796 5.80025 16.6657 4.88159 15.8919 4.10777C15.1181 3.33395 14.1994 2.72012 13.1884 2.30133C12.1773 1.88254 11.0937 1.66699 9.99935 1.66699ZM9.16602 14.167H10.8327V9.16699H9.16602V14.167Z",
    fill: "#5A30B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleInfo);
export default __webpack_public_path__ + "static/media/purple-info.47a4f99474b8ab206d66cd45bb8b662c.svg";
export { ForwardRef as ReactComponent };